import { useSettings } from "@/lib/settings";
import { API_BASE } from "@/lib/api";
import { Link } from "react-router-dom";

function resolveUrl(u) {
  if (!u) return null;
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  if (u.startsWith("/api/uploads/")) return `${API_BASE.replace(/\/api$/, "")}${u}`;
  return u;
}

export default function Logo({ variant = "dark", size = "md" }) {
  const { settings } = useSettings();
  const iconHeights = { sm: "h-8", md: "h-10", lg: "h-14" };
  const textSizes = { sm: "text-lg", md: "text-2xl", lg: "text-3xl" };
  const iconHeight = iconHeights[size] || iconHeights.md;
  const textSize = textSizes[size] || textSizes.md;
  const textColor = variant === "light" ? "text-white" : "text-[#0a1e3f]";
  const taglineColor = variant === "light" ? "text-white/70" : "text-[#4b5563]";
  const customLogo = resolveUrl(settings.logo_url);

  return (
    <Link to="/" className="inline-flex items-center gap-2.5" data-testid="site-logo">
      {customLogo ? (
        <img src={customLogo} alt={settings.site_name} className={`${iconHeight} w-auto object-contain max-w-[180px]`} />
      ) : (
        <>
          <img src="/mobika-icon.png" alt="" className={`${iconHeight} w-auto object-contain shrink-0`} />
          <div className="leading-tight">
            <div className={`mbk-logo font-black tracking-[0.06em] ${textSize} ${textColor}`}>
              {settings.site_name || "MOBIKAR"}
            </div>
            <div className={`text-[9px] uppercase tracking-[0.15em] font-semibold ${taglineColor} hidden sm:block`}>
              {settings.tagline}
            </div>
          </div>
        </>
      )}
    </Link>
  );
}
